import cookie from './getCookie.js'
export default{
    isLogin(){
        var shareSchoolId= null;
        let websiteId = localStorage.getItem('websiteId');
        console.log(websiteId,'32222')
         const cookie_token = cookie.getCookie('AXY_'+ websiteId +'_access_token')
         if(cookie_token){
             if(cookie_token != 'null'){
                 //console.log('以登录',cookie_token)
                 shareSchoolId = localStorage.getItem('schoolId');
                 console.log('是否有cookie',localStorage.getItem('schoolId'))
             }
         }else{
             //console.log('未登录',cookie_token)
             shareSchoolId = null;
         }
         console.log(shareSchoolId)
         return shareSchoolId
    }
   
}


// WEBPACK FOOTER //
// ./src/assets/isLogin.js